import { TableHeaders } from "../../models/Headers";
import pageImpl from "../../models/PageImpl";
import NN05FormEmployeeData from "../../models/payload/NN05FormEmployeeData";
import * as actionTypesNN05 from "./actionTypesNN05";

//
export const NN05PERSONListeGetStart = () => {
  return { type: actionTypesNN05.NN05_EMPLOYEELIST_GET_INIT };
};

//
export const NN05PERSONListeGet = (listFormData: FormData = new FormData()) => {
  return { type: actionTypesNN05.NN05_EMPLOYEELIST_GET, listFormData };
};

//
export const NN05PERSONListeGetSuccess = (payload: pageImpl<any>) => {
  return { type: actionTypesNN05.NN05_EMPLOYEELIST_GET_SUCCESS, payload };
};

//
export const NN05PERSONListeGetFailed = (error: any) => {
  return { type: actionTypesNN05.NN05_EMPLOYEELIST_GET_FAILED, error };
};

export const NN05ResetForm = (payload: any) => {
  return { type: actionTypesNN05.NN05_RESET_FORM, payload };
};

//  Set Reset state enabled
export const NN05SetResetFormEnabled = (payload: any) => {
  return { type: actionTypesNN05.NN05_SET_RESET_FORM_ENABLED, payload };
};

//  Reset form
export const NN05ClearComponentStore = () => {
  return { type: actionTypesNN05.NN05_RESET_COMPONENT_STORE };
};

//  Update Column Header List
export const NN05UpdateColumnHeaderList = (list: TableHeaders[]) => {
  return { type: actionTypesNN05.NN05_SET_COLUMN_HEADER_LIST, list };
};

// 
export const setKeyValuePairs4NN05 = (payload: any) => {
  return { type: actionTypesNN05.SET_KEY_VALUE_PAIRS_4_NN05, payload };
};


export const setCurrentRowFocused = (payload: any) => {
  return { type: actionTypesNN05.SET_CURRENT_ROW_FOCUSED, payload };
};

export const setScrollTopPosition = (payload: any) => {
  return { type: actionTypesNN05.SET_SCROLL_TOP_POSITION, payload };
}

export const setTransStateInsertEmployee = (payload: any) => {
  return { type: actionTypesNN05.SET_TRANS_STATE_INSERT_PERSON, payload };
}

export const setTransStateUpdateEmployee = (payload: any) => {
  return { type: actionTypesNN05.SET_TRANS_STATE_UPDATE_PERSON, payload };
}

export const setTransStateDeleteEmployee = (payload: any) => {
  return { type: actionTypesNN05.SET_TRANS_STATE_DELETE_PERSON, payload };
}

export const setTransStateDialogEmployee = (payload: any) => {
  return { type: actionTypesNN05.SET_TRANS_STATE_DIALOG_PERSON, payload };
}

export const setSelelectedEmployee = (payload: any) => {
  return { type: actionTypesNN05.SET_SELECTED_PERSON, payload };
}
export const setRawData = (payload: any) => {
  return { type: actionTypesNN05.SET_ROWDATA, payload };
}

export const setListFormData = (payload: any) => {
  return { type: actionTypesNN05.SET_LIST_FORMDATA, payload };
}

export const setSubFormData = (payload: any) => {
  return { type: actionTypesNN05.SET_SUB_FORMDATA, payload };
}

export const setTransInsertEmployee = ({ data, listFormData }: { data: NN05FormEmployeeData, listFormData?: any }) => {
  return { type: actionTypesNN05.SET_TRANS_INSERT_EMPLOYEEPOST, data, listFormData };
};

export const setTransUpdateEmployee = ({ data, listFormData }: { data: NN05FormEmployeeData, listFormData?: any }) => {
  return { type: actionTypesNN05.SET_TRANS_UPDATE_EMPLOYEEPOST, data, listFormData };
};

export const setTransDeleteEmployee = ({ data, listFormData }: { data: NN05FormEmployeeData, listFormData?: any }) => {
  return { type: actionTypesNN05.SET_TRANS_DELETE_EMPLOYEEPOST, data, listFormData };
};

export const setTransDialogEmployeeFeedback = (payload: any) => {
  return { type: actionTypesNN05.SET_TRANS_DIALOG_EMPLOYEE_FEEDBACK, payload };
};

export const getEmployeeId = () => {
  return { type: actionTypesNN05.NN05_EMPLOYEE_ID_GET };
};

export const getEmployeeIdSuccess = (payload: any) => {
  return { type: actionTypesNN05.NN05_EMPLOYEE_ID_GET_SUCCESS, payload };
};

export const getEmployeeIdFailed = (payload: any) => {
  return { type: actionTypesNN05.NN05_EMPLOYEE_ID_GET_FAILED, payload };
};

export const getEmployeeIdValidate = (payload: any) => {
  return { type: actionTypesNN05.NN05_EMPLOYEE_ID_VALIDATE_GET, payload };
};

export const getEmployeeIdValidateSuccess = (payload: any) => {
  return { type: actionTypesNN05.NN05_EMPLOYEE_ID_VALIDATE_GET_SUCCESS, payload };
};

export const getEmployeeIdValidateFailed = (payload: any) => {
  return { type: actionTypesNN05.NN05_EMPLOYEE_ID_VALIDATE_GET_FAILED, payload };
};

export const getLocationByPostalCode = (payload: any) => {
  return { type: actionTypesNN05.NN05_LOCATION_BY_POSTALCODE_GET, payload };
};
export const getLocationByPostalCodeSuccess = (payload: any) => {
  return { type: actionTypesNN05.NN05_LOCATION_BY_POSTALCODE_GET_SUCCESS, payload };
};
export const getLocationByPostalCodeFailed = (payload: any) => {
  return { type: actionTypesNN05.NN05_LOCATION_BY_POSTALCODE_GET_FAILED, payload };
};

export const setLockKeypressed = (payload: any) => {
  return { type: actionTypesNN05.SET_LOCK_KEYPRESS, payload };
}
